import { jwtDecode } from 'jwt-decode';

export const isTokenExpired = async(token) => {
    try {
      const decoded = jwtDecode(token);
      const currentTime = Math.floor(Date.now() / 1000);
      return decoded.exp < currentTime;
    } catch (error) {
      console.error('Error decoding token:', error);
      return true;
    }
  };

    // Helper function to validate URLs
export const validateUrl = (url) => {
    try {
      const parsedUrl = new URL(url);
      // Ensure the URL is using HTTP or HTTPS protocols
      if (parsedUrl.protocol !== 'http:' && parsedUrl.protocol !== 'https:') {
        console.error('Invalid protocol:', parsedUrl.protocol);
        return false;
      }
  
      // Disallow URLs pointing to internal IP ranges
      const hostname = parsedUrl.hostname;
      if (isInternalIp(hostname)) {
        console.error('Internal IP not allowed:', hostname);
        return false;
      }
  
      return true;
    } catch (error) {
      console.error('Invalid URL format:', error);
      return false;
    }
  };

  // Helper function to check if the IP is internal
const isInternalIp = (hostname) => {
  // Regex for IPv4 and IPv6 private addresses and localhost
  const privateIpRegex =
    /^(localhost|127\.0\.0\.1|::1|10\.\d{1,3}\.\d{1,3}\.\d{1,3}|172\.(1[6-9]|2\d|3[01])\.\d{1,3}\.\d{1,3}|192\.168\.\d{1,3}\.\d{1,3}|fc00::|fe80::)/;

  return privateIpRegex.test(hostname);
};